import createIcon from '@/lib/create-icon'

const CoinIcon = createIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      d='M15.0008 9.63748V8.84998M15.0008 14.3625V15.15M13.6346 13.8C13.9523 14.3192 14.4567 14.3652 15.0017 14.3652C15.7356 14.3652 16.5758 14.1915 16.5758 13.26C16.5758 12.7524 16.2302 12.3105 15.7388 12.1863L14.2628 11.8155C13.7723 11.6922 13.4258 11.2494 13.4258 10.7418C13.4258 9.81019 14.2659 9.63658 14.9999 9.63658C15.5438 9.63658 16.0483 9.68116 16.3661 10.1991M3 12H6.5M5 8H7M5 16H7M21 12C21 15.3137 18.3137 18 15 18C11.6863 18 9 15.3137 9 12C9 8.68629 11.6863 6 15 6C18.3137 6 21 8.68629 21 12Z'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>,
  'CoinIcon'
)

export default CoinIcon
